import Objdict from "objdict"

import Geometry from "@frog/source/utility/Geometry.js"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Stage from "@frog/source/models/Stage.js"
import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Reactions from "@frog/source/models/Reactions.js"
import Action from "@frog/source/models/Action.js"

import skills from "@frog/source/data/skills.js"
import unitJobs from "@frog/source/data/unitJobs.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotFlourishes from "@frog/source/data/plot/flourishes.js"

import Speedtest from "@frog/source/engine/testing/utility/Speedtest.js"

const MAX_INFLUENCE = 200 // this is duped in Stage.js
const INFLUENCE_ITERATIONS = 10
const INFLUENCE_DECAY = 20
const MOVE_COST = 1

export default class Unit {
    static instantiate({unit, player, gameSlug, chapterSlug, random}) {
        const baseUnit = {
            "key": random.identifier(5),
            "energy": {"move": true, "invoke skill": true},
            "inventory": {"items": {}},
            "effects": {},
            "skillKeys": [],
            "equippedSkillKeys": {},
            "position": {"x": 0, "y": 0, "z": 0},
            "state": "aggroed", // or "idle"
            "maxhealth": 5,
        }

        player = player || App?.game?.player
        let partyUnit = player?.party?.units[unit.key] || {}
        unit = Objdict.merge(partyUnit, unit)

        let unitJob = {}
        if(unit.randomJobKey != undefined) {
            const jobKeys = []
            unit.randomJobKey.split(",").forEach((jobKey) => {
                jobKey = jobKey.trim()
                jobKeys.push(jobKey)
            })
            unit.jobKey = random.elementFromSeededKey(jobKeys, unit.key)
        }
        if(unit.jobKey != undefined) {
            unitJob = unitJobs[gameSlug + "/" + chapterSlug + "/" + unit.jobKey]
                || unitJobs[gameSlug + "/" + unit.jobKey]
                || unitJobs[unit.jobKey]
            if(unitJob == undefined) {
                // console.log("Could not find unit class", unit.jobKey, unit)
                unitJob = {}
            }
        }

        const mergedUnit = Objdict.merge(baseUnit, unitJob, unit)

        mergedUnit.skillKeys = mergedUnit.skillKeys || []
        if(mergedUnit.equippedItem === undefined) {
            mergedUnit.equippedItem = mergedUnit.primaryItem
        }

        delete unit.actionmap // we do not instantiate action maps!!!

        mergedUnit.maxhealth = mergedUnit.maxhealth ?? 0
        mergedUnit.maxarmor = mergedUnit.maxarmor ?? 0
        if(mergedUnit.health === undefined) {
            mergedUnit.health = mergedUnit.maxhealth
        }
        if(mergedUnit.armor === undefined
        && mergedUnit.maxarmor !== undefined) {
            mergedUnit.armor = mergedUnit.maxarmor
        }

        if(mergedUnit.maxexperience != undefined) {
            mergedUnit.experience = mergedUnit.experience || 0
        }

        mergedUnit.skillKeys = mergedUnit.skillKeys.concat(mergedUnit.unlockedSkillKeys)

        return mergedUnit
    }
    static computeInfluenceMap(affiliation, stage, position, performer) {
        let influence = {}

        // THIS IS THE PROBLEM
        const INFLUENCE_ZONE = stage.encounters[stage.currentEncounterKey] || {}

        const things = {}
        const trees = {}

        if(affiliation == stage.player.affiliation) return influence

        Objdict.forEach(stage.units, (unit) => {
            if(Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position) == false) {
                return
            }
            if(unit.affiliation != affiliation
            && unit.affiliation != "none"
            && unit.affiliation != "nothing"
            && unit.type != "zone"
            && unit.type != "spot"
            && unit.type != "thing"
            && unit.isDead != true
            && unit.isRemoved != true) {
                influence[unit.position.x + "x" + unit.position.y] = MAX_INFLUENCE
            }

            if(unit.type == "thing") {
                things[unit.position.x + "x" + unit.position.y] = true
            }

            if(unit.role == "tree") {
                trees[unit.position.x + "x" + unit.position.y] = true
            }
        })

        // Do a heatmap of heading towards goodies
        for(let i = 0; i < INFLUENCE_ITERATIONS; i += 1) {
            let nextInfluence = {}
            for(let x = INFLUENCE_ZONE.x1; x <= INFLUENCE_ZONE.x2; x += 1) {
                for(let y = INFLUENCE_ZONE.y1; y <= INFLUENCE_ZONE.y2; y += 1) {
                    if(things[x + "x" + y] == true && performer.movetype != "incorporeal") continue
                    if(trees[x + "x" + y] == true && performer.movetype == "cumbersome") continue

                    const terrain = stage.world.terrain[x + "x" + y]
                    if(terrain == undefined) continue
                    const z = terrain.position.z + (terrain.size.z ?? 1)

                    const position = {x, y, z}
                    nextInfluence[position.x + "x" + position.y] = influence[position.x + "x" + position.y] || 0
                    Geometry.getNeighborPoints(position).forEach((nextPosition) => {
                        // // this call to Stage.findCollision and it's call to World.hasCollision is the current slowdown :T
                        // const collision = Stage.findCollision({
                        //     "stage": stage,
                        //     "previousPosition": position,
                        //     "nextPosition": nextPosition
                        // })
                        //
                        // if(collision != undefined) {
                        //     if(collision.type == "world") return
                        // }
                        const value = (influence[nextPosition.x + "x" + nextPosition.y] || 0) - INFLUENCE_DECAY
                        if(nextInfluence[position.x + "x" + position.y] < value) {
                            nextInfluence[position.x + "x" + position.y] = value
                        }
                    })
                }
            }
            influence = nextInfluence
        }

        // // Do a heatmap of heading towards the center of the map.
        // const LONGEST_DISTANCE = 13
        // const zone = stage.encounters[stage.currentEncounterKey].zone || {}
        // const centerpoint = {
        //     "x": zone.x + (zone.width / 2),
        //     "y": zone.y + (zone.height / 2),
        // }
        // for(let x = 0; x <= stage.world.width; x += 1) {
        //     for(let y = 0; y <= stage.world.height; y += 1) {
        //         const terrain = stage.world.terrain[x + "x" + y]
        //         if(terrain == undefined) continue
        //         const z = terrain.position.z + terrain.size.z
        //         const position = {x, y, z, "key": x + "x" + y}
        //
        //         influence[position.key] = (1 - (Geometry.distance(position, centerpoint) / LONGEST_DISTANCE)) * MAX_INFLUENCE
        //     }
        // }

        // // Do a heatmap of heading towards the CLOSEST goodie.
        // const LONGEST_DISTANCE = 13
        // const targetUnit = Object.values(stage.units).filter((unit) => {
        //     return unit.affiliation == "good"
        //         && unit.isRemoved != true
        //         && unit.isDead != true
        //         && unit.type != "zone"
        // }).map((unit) => {
        //     return {unit, "distance": Geometry.distance(unit.position, position)}
        // }).sort((a, b) => {
        //     if(a.distance < b.distance) return -1
        //     if(a.distance > b.distance) return +1
        //     return 0
        // })[0]
        // for(let x = 0; x <= stage.world.width; x += 1) {
        //     for(let y = 0; y <= stage.world.height; y += 1) {
        //         const terrain = stage.world.terrain[x + "x" + y]
        //         if(terrain == undefined) continue
        //         const z = terrain.position.z + terrain.size.z
        //         const position = {x, y, z, "key": x + "x" + y}
        //
        //         influence[position.key] = (1 - (Geometry.distance(position, targetUnit.position) / LONGEST_DISTANCE)) * MAX_INFLUENCE
        //     }
        // }

        return influence
    }

    // This function will return an actionmap, a
    // hash of all the possible actions the given
    // unit could perform within range. An "action"
    // can be a move, an attack, an assist, etc.
    static calculateActions(performerKey, stage, {calculateInfluenceMap} = {}) {
        const mark = Speedtest.mark("Actions", "Unit.calculateActions")

        if(stage == undefined) throw new Error("requires action.stage")
        if(performerKey == undefined) throw new Error("requires action.performerKey")

        const startingAction =  {}

        const performer = stage.units[performerKey]
        if(performer == undefined) {
            throw new Error("Could not find unit " + performerKey + " in the stage.")
        }

        if(performer.type == "thing") return
        if(performer.affiliation != stage.player.affiliation && performer.ai?.behaviors?.includes("inactive")) return
        if(performer.isRemoved) return
        if(performer.isDead) return

        startingAction.performerKey = performerKey
        startingAction.isStartingAction = true
        startingAction.type = performer.energy["move"] == true ? "wait" : "wait - invoke skill"
        startingAction.position = performer.position
        startingAction.alphastage = startingAction.omegastage = Stage.copy(stage)
        startingAction.distance = performer.energy["move"] == true ? 0 : performer.moverange.max
        startingAction.steps = []

        const submark = Speedtest.mark("Unit.calculateAction", "influence map")
        if(calculateInfluenceMap !== false) {
            startingAction.influenceMap = Unit.computeInfluenceMap(performer.affiliation, startingAction.alphastage, performer.position, performer)
            submark()
        }

        const actionmap = {}

        Unit.populateActionMap(actionmap, startingAction)
        Unit.pruneInternalActionMapData(actionmap)

        mark()
        return actionmap
    }
    static populateActionMap(actionmap, stubAction) {
        const calculatedAction = Unit.calculateAction(stubAction)
        if(calculatedAction == undefined) return
        Unit.saveAction(actionmap, calculatedAction)
        if(calculatedAction.nextActions != undefined) {
            calculatedAction.nextActions.forEach((nextAction) => {
                Unit.populateActionMap(actionmap, nextAction)
            })
        }
    }
    static calculateAction(action) {
        const mark1 = Speedtest.mark("Unit.calculateAction", "initialization")

        if(action.type === undefined) throw new Error("requires action.type")
        if(action.position === undefined) throw new Error("requires action.position")
        if(action.performerKey === undefined) throw new Error("requires action.performerKey")
        if(action.alphastage === undefined) throw new Error("requires action.alphastage")

        action.alphastage = Stage.copy(action.alphastage)

        // If nothing else happens, the omegastage
        // will match the alphastage. But throughout
        // this action, the omegastage will be cloned
        // and edited via the game logic.
        action.omegastage = action.alphastage

        action.positions = [{...action.position, "type": action.type}]
        action.steps = []

        action.priority = 0

        if(action.previousAction != undefined) {
            action.positions = action.positions.concat(action.previousAction.positions)

            action.previousAction.positions.slice().reverse().forEach((position, index) => {
                if(index == 0) return
                Action.addStep(action, Step.instantiate(PlotSteps.MoveUnitStep({
                    "stage": action.omegastage,
                    "unitKey": action.performerKey,
                    "position": position,
                })))
            })
        }

        mark1()

        ///////////////////////////////
        // Unit-to-World Collision  //
        /////////////////////////////

        const mark2 = Speedtest.mark("Unit.calculateAction", "unit-to-world collision")

        const previousPosition = action.positions[1] || action.position
        const nextPosition = action.positions[0] || action.position

        if(action.type == "invoke skill") {
            if(World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                mark2()
                return
            }
            if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounterKey].zone, nextPosition)) {
                mark2()
                return
            }
            const skill = skills.get(action.skillKey)
            if(skill == undefined) {
                mark2()
                return
            }

            if(skill.range && skill.range.type != "arc") {
                if(Dev.isAllyCollisionEnabled == true
                && World.hasCollision({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounterKey].zone,
                })) {
                    mark2()
                    return
                }

                // const previousTerrain = World.getTerrain(action.alphastage.world, previousPosition)
                // const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                // const zDistance = Math.abs((previousTerrain.position.z + previousTerrain.size.z) - (nextTerrain.position.z + nextTerrain.size.z))
                // // Let units move between blocks if there is only
                // // a half-block delta! (ramps are considered half-blocks)
                // const MOVEMENT_SIZE = 1
                // if(zDistance <= MOVEMENT_SIZE) {
                //     action.position.z = nextTerrain.position.z + nextTerrain.size.z
                // }
            }

            // if(skill.range && skill.range.type == "arc") {
            //     const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
            //     if(nextTerrain != undefined) {
            //         // if(nextTerrain.shape == "obstruction") {
            //         //     mark2()
            //         //     return
            //         // }
            //         action.position.z = nextTerrain.position.z + nextTerrain.size.z
            //     }
            // }
        }

        if(action.type == "move") {
            const alphaperformer = action.alphastage.units[action.performerKey]
            if(alphaperformer.movetype == "flying") {
                if(Dev.isAllyCollisionEnabled == true
                // && alphaperformer.movetype != "incorporeal"
                && World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                    mark2()
                    return
                }
            } else {
                if(Dev.isAllyCollisionEnabled == true
                // && alphaperformer.movetype != "incorporeal"
                && World.hasCollision({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounterKey].zone,
                })) {
                    mark2()
                    return
                }

                if(alphaperformer.movetype != "mobile"
                && alphaperformer.movetype != "incorporeal") {
                    if(action.distance > 0) {
                        const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                        const tree = Object.values(action.omegastage.units).find((unit) => {
                            return unit.position.x == nextPosition.x
                                && unit.position.y == nextPosition.y
                                && unit.role == "tree"
                        })

                        if(nextTerrain != undefined
                        && nextTerrain.isTree == true
                        || tree != undefined) {
                            if(alphaperformer.movetype == "mounted"
                            || alphaperformer.movetype == "cumbersome") {
                                mark2()
                                return
                            }
                            if(action.distance > MOVE_COST) {
                                mark2()
                                return
                            }
                            action.distance += MOVE_COST * 3
                        }
                    }
                }
            }
        }

        mark2()

        /////////////////////////////
        // Unit-to-Unit Collision //
        ///////////////////////////

        const mark3 = Speedtest.mark("Unit.calculateAction", "unit-to-unit collision")

        if(action.type == "move") {
            const performer = action.alphastage.units[action.performerKey]
            const positionedUnits = Stage.findUnitsByPosition(action.alphastage, action.position, {"excludeUnitKey": action.performerKey, "includingZones": true})
            let collidingUnit = positionedUnits.find((unit) => {

                if(unit == undefined) return
                if(unit.type == "zone" || unit.type == "spot") {
                    return false
                }
                if(performer.movetype == "incorporeal"
                && unit.type == "thing") { // book
                    return false
                }

                if(unit.affiliation == performer.affiliation) {
                    action.type = "move through"
                    return false
                } else {
                    action.type = "move - colliding unit"
                    return true
                }
            })

            if(collidingUnit != undefined) {
                mark3()
                return
            }
        }

        if(action.type == "invoke skill"
        && skills.get(action.skillKey).canTarget instanceof Function) {
            if(skills.get(action.skillKey).canTarget({"performerKey": action.performerKey, "stage": action.alphastage, "position": action.position}) == false) {
                action.type = "invoke skill - can not target"
                if(skills.get(action.skillKey).isRenderedEvenIfCanNotTarget != true) {
                    mark3()
                    return
                }
            }
        }

        mark3()

        ///////////////////////////////
        // Calculate the Omegastage //
        /////////////////////////////

        const mark4 = Speedtest.mark("Unit.calculateAction", "omegastage calculation")

        if(action.type == "wait"
        && action.omegastage.units[action.performerKey].properties?.includes("unstoppable") != true) {
            action.priority = 3
            Action.addStep(action, Step.instantiate({
                "type": "exhaust energy",
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "units": {
                            [action.performerKey]: {
                                "energy": {
                                    "move": false,
                                }
                            }
                        }
                    },
                ]
            }))
        }

        if(action.type == "move"
        || action.type == "move through") {
            action.priority = 2
            // if(action.direction != undefined) {
            //     Action.addStep(action, Step.instantiate({
            //         "type": "turn",
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "unit": {
            //                     "key": action.performerKey,
            //                     "direction": action.direction,
            //                 }
            //             }
            //         ]
            //     }))
            // }
            // const performer = action.omegastage.units[action.performerKey]

            // // If you want to move the unit without any animation, you
            // // need only perform a raw unit position move, without
            // // any of the fancy tweening motion we use from the plotscript.
            // Action.addStep(action, Step.instantiate({
            //     "alphastage": action.omegastage,
            //     "deltastage": {
            //         "unit": {
            //             "key": action.performerKey,
            //             "position": action.position,
            //         }
            //     }
            // }))

            Action.addStep(action, Step.instantiate(PlotSteps.MoveUnitStep({
                "stage": action.omegastage,
                "unitKey": action.performerKey,
                "position": action.position,
            })))

            Action.addStep(action, Reactions.getSteps(action.omegastage))

            if(action.type == "move"
            && action.omegastage.units[action.performerKey].properties?.includes("unstoppable") != true) {
            // && action.distance >= omegaperformer.moverange
            // && omegaperformer.energy.move != true) {
                Action.addStep(action, Step.instantiate({
                    "type": "exhaust energy",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "units": {
                                [action.performerKey]: {
                                    "energy": {
                                        "move": false,
                                    }
                                }
                            }
                        },
                    ]
                }))

                if(action.omegastage.scripts != undefined) {
                    action.omegastage.scripts.forEach((script) => {
                        if(script.trigger == "moving") {
                            if(script.canBeTriggered instanceof Function) {
                                if(script.canBeTriggered(action.omegastage) == false) {
                                    return
                                }
                            }
                            Action.addStep(action, Stage.processEventSteps(action.omegastage, script.events))
                        }
                    })
                }
            }

        }


        if(action.type == "invoke skill"
        && action.skillKey != undefined) {
            // if(action.direction != undefined) {
            //     Action.addStep(action, Step.instantiate({
            //         "type": "turn",
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "unit": {
            //                     "key": action.performerKey,
            //                     "direction": action.direction,
            //                 }
            //             }
            //         ]
            //     }))
            // }

            // const performer = action.omegastage.units[action.performerKey]
            // const target = Stage.findUnitAtPosition(action.omegastage, action.position)
            // if(target != undefined) {
            //     action.targetAffiliation = target.affiliation
            // }
            //
            //
            // // CONVO // DEBUG
            // const conversation = getConversation(action)
            //
            // if(conversation != undefined
            // && conversation.dialogue != undefined) {
            //     conversation.dialogue.forEach((dialogue) => {
            //         Action.addStep(action, Step.instantiate({
            //             "type": "say",
            //             "alphastage": action.omegastage,
            //
            //             "deltastages": [
            //                 {
            //                     "mark": 0,
            //                     "dialogue": {
            //                         "text": dialogue.text,
            //                         "portrait": dialogue.portrait,
            //                     }
            //                 }
            //             ],
            //             "isImportant": true,
            //             "duration": Infinity,
            //         }))
            //     })
            //     Action.addStep(action, Step.instantiate({
            //         "type": "unsay",
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "dialogue": null
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation != undefined
            // && conversation.changeTargetAffiliationTo != undefined) {
            //     Action.addStep(action, Step.instantiate({
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "unit": {
            //                     "key": target.key,
            //                     "affiliation": conversation.changeTargetAffiliationTo == "me" ? action.alphastage.units[action.performerKey].affiliation : conversation.changeTargetAffiliationTo,
            //                 }
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation == undefined
            // || conversation.type == "invoke skill"
            // || conversation.alsoInvokeSkill == true) {
            const skill = skills.get(action.skillKey)

            action.role = skill.role

            // 2 is movement, 3 is waiting, 4 is most skills, 5+ is a priority skill.
            action.priority = 4
            if(skill.getPriority instanceof Function) {
                action.priority = skill.getPriority({
                    "performerKey": action.performerKey,
                    "position": action.position,
                    "stage": action.omegastage,
                }) ?? action.priority
            }

            if(action.item != undefined) {
                if(action.skillKey != "book/brandish" && action.omegastage.units[action.performerKey]?.equippedItem?.skillKeys?.includes("book/unbrandish")) { // book
                    Object.values(action.omegastage.units).forEach((unit) => {
                        if(unit.stimuli != undefined
                        && unit.stimuli["unbrandish:" + action.omegastage.units[action.performerKey]?.equippedItem?.key]) {
                            Action.addStep(action, Step.instantiate({
                                "alphastage": action.omegastage,
                                "deltastage": {
                                    "unit": {
                                        "key": unit.key,
                                        // "role": "visible",
                                        "state": unit.stimuli["unbrandish:" + action.omegastage.units[action.performerKey]?.equippedItem?.key]
                                    }
                                }
                            }))
                        }
                    })
                }
                Action.addStep(action, Step.instantiate({
                    "type": "equip item",
                    "alphastage": action.omegastage,
                    "deltastage": {
                        "unit": {
                            "key": action.performerKey,
                            "equippedItem": action.item,
                        }
                    }
                }))
            }

            if(skill.calculateStep instanceof Function) {
                const step = skill.calculateStep({
                    "performerKey": action.performerKey,
                    "position": action.position,
                    "stage": action.omegastage,
                })
                Action.addStep(action, step)
                if(step != undefined
                && step.followupSteps != undefined) {
                    step.followupSteps.forEach((followupStep) => {
                        Action.addStep(action, followupStep)
                        // TODO: Do we have any gaurentee that these
                        // followup steps are respecting the invoke skill step.omegastage?
                        // and that we can use it without killing and undoing the invoke skill?
                    })
                }
            }

            /////////////
            // DEATHS //
            ///////////
            Action.addStep(action, Reactions.getSteps(action.omegastage, {"actingUnitKey": action.performerKey}))
            Action.addStep(action, Unit.calculateActionExperience(action.alphastage, action.omegastage, action.performerKey, Stage.findUnitAtPosition(action.alphastage, action.position)?.key, action.skillKey))

            if(action.omegastage.units[action.performerKey] == undefined) {
                return action
            }

            //////////////////////
            // COUNTER-ATTACKS //
            ////////////////////

            if(skills.get(action.skillKey).canBeCounterattacked) {
                const targetedUnit = Stage.findUnitAtPosition(action.alphastage, action.position)
                if(targetedUnit != undefined
                && action.omegastage.units[targetedUnit.key] != undefined
                && action.omegastage.units[targetedUnit.key].isDead != true) {

                    const target = action.omegastage.units[targetedUnit.key]
                    const performer = action.omegastage.units[action.performerKey]

                    let targetSkillKeys = target.skillKeys
                    if(target.equippedItem != undefined) {
                        targetSkillKeys = targetSkillKeys.concat(target.equippedItem.skillKeys || target.equippedItem.skillKey)
                    }

                    const counterattackSkillKey = Objdict.find(targetSkillKeys, (skillKey) => {
                        return skills.get(skillKey) != undefined
                            && (skills.get(skillKey).type == "counterattack" || (skills.get(skillKey).canCounterattack === true || (skills.get(skillKey).canCounterattack instanceof Function && skills.get(skillKey).canCounterattack({"performerKey": target.key, "stage": action.omegastage, "position": performer.position}))))
                            && Geometry.isWithinRange(target.position, performer.position, skills.get(skillKey).range ?? target.equippedItem?.attackrange ?? target.attackrange) // DOES NOT RESPECT Z
                            && (skills.get(skillKey).canTarget instanceof Function == false
                            || skills.get(skillKey).canTarget({"performerKey": target.key, "stage": action.omegastage, "position": performer.position}) == true)
                            // If you ever want this to be a "on damage" rather than a fire-emblem-style counterattack
                            // then remove this Geometry.isWithinRange condition.
                    })
                    // const vector = Geometry.difference(performer.position, target.position)
                    // const direction = {"x": 0, "y": 0}
                    // if(vector.x == 0 && vector.y != 0) {
                    //     direction.y = Math.sign(vector.y)
                    // } else if(vector.x != 0 && vector.y == 0) {
                    //     direction.x = Math.sign(vector.x)
                    // } else if(vector.x != 0 && vector.y != 0) {
                    //     if(Math.abs(vector.x) > Math.abs(vector.y)) {
                    //         direction.x = Math.sign(vector.x)
                    //     } else {
                    //         direction.y = Math.sign(vector.y)
                    //     }
                    // }
                    // TODO: read a direction from the deltaunit, so the skills can define
                    // the direction of damage instead of this ungrokable math equation.
                    // const position = Geometry.add(target.position, direction)
                    if(counterattackSkillKey != undefined) {
                        const skill = skills.get(counterattackSkillKey)
                        if(skill.calculateStep instanceof Function) {
                            const step = skill.calculateStep({
                                "performerKey": target.key,
                                "position": performer.position,
                                "stage": action.omegastage,
                            })
                            Action.addStep(action, step)
                        }

                        Action.addStep(action, Reactions.getSteps(action.omegastage, {"actingUnitKey": target.key}))
                        Action.addStep(action, Unit.calculateActionExperience(action.alphastage, action.omegastage, target.key, action.performerKey, counterattackSkillKey, {"isCounterattack": true}))
                    }
                }

                if(action.omegastage.units[action.performerKey] == undefined) {
                    return action
                }
            }

            /////////////
            // ENERGY //
            ///////////

            if(action.omegastage.units[action.performerKey].properties?.includes("unstoppable") != true) {
                if(action.omegastage.units[action.performerKey].properties?.includes("can act twice")
                && ((action.omegastage.units[action.performerKey].energy.invokeCount || 0) + 1) < 2) {
                    Action.addStep(action, Step.instantiate({
                        "type": "exhaust energy",
                        "alphastage": action.omegastage,
                        "deltastage": {
                            "unit": {
                                "key": action.performerKey,
                                "energy": {
                                    "move": action.skillKey == "dash" ? true : false,
                                    "invokeCount": (action.omegastage.units[action.performerKey].energy.invokeCount || 0) + 1,
                                }
                            }
                        }
                    }))
                } else {
                    Action.addStep(action, Step.instantiate({
                        "type": "exhaust energy",
                        "alphastage": action.omegastage,
                        "deltastage": {
                            "unit": {
                                "key": action.performerKey,
                                "energy": {
                                    "move": action.skillKey == "dash" ? true : false,
                                    "invoke skill": false,
                                }
                            }
                        }
                    }))
                }
            }
        }

        // const light = "hello world"
        // Action.addStep(action, Step.instantiate({
        //     "type": "recalculate light",
        //     "alphastage": action.omegastage,
        //     "deltastages": [
        //         {
        //             "light": light
        //         }
        //     ]
        // }))

        // Action.addStep(action, Step.instantiate({
        //     "type": "increment stage.actionMark",
        //     "alphastage": action.omegastage,
        //     "deltastages": [{"actionMark": (action.omegastage.actionMark || 0) + 1}]
        // }))

        // /////////////////////
        // // Passive Skills //
        // ///////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // Speedtest.point("apply passives")
        //
        // action.alphastage.units.forEach((shadowunit) => {
        //     if(shadowunit.skillKeys != undefined) {
        //         shadowunit.skillKeys.forEach((skill) => {
        //             if(skill.type == "passive"
        //             && skill.trigger == "reaction") {
        //                 skill.editResults(action, shadowunit)
        //             }
        //         })
        //     }
        // })

        // //////////////////////
        // // Counter-Attacks //
        // ////////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // // DON'T WE ALREADY HAVE THIS UP ABOVE?
        /// /// DOES NOT RESPECT ACTION.PERFORMERKEY
        // Speedtest.point("predict counter-attacks")
        //
        // if(action.type === "invoke"
        // && action.skill.canBeCountered != true
        // && action.alphastage.units.target.health + ((action.results && action.results.target && action.results.target.health) || 0) > 0) {
        //     let counterskill = action.target.skillKeys.find((skill) => {
        //         return skill.type == "counterattack"
        //             && skill.canTarget(action.performer, action.target, action, action.stage)
        //     })
        //     if(!!counterskill) {
        //         action.counterAction = {
        //             "type": "invoke",
        //             "skill": counterskill,
        //             "target": action.performer,
        //             "performer": action.target,
        //             "results": counterskill.calculateDeltastages(action.performer, action.target, true /*isCounterAction*/, {"units": action.alphastage.units}, action)
        //         }
        //     }
        // }
        //
        // // // TODO: also shadow the counter actions
        // // if(action.counterAction != undefined) {
        // //     if(action.counterAction.results != undefined
        // //     && action.counterAction.results.target != undefined
        // //     && action.counterAction.results.target.health != undefined) {
        // //         shadowunit.health += action.counterAction.results.target.health
        // //     }
        // //     // TODO: am i reading this right? we only predict target health for
        // //     // counteractions. no performer health, no target position.
        // // }

        // TODO: Aggregate all the step results into a common result object.

        // // TODO: Revisit calculating the FUTURE state of next turn if the
        // // players chose to end their turn right after this action, mostly
        // // including end-of-turn effects.
        // startTurnEffects.forEach((effect) => {
        //     const results = effect.calculateDeltastages({
        //         "previousState": action.quantumstate["turn:=0"]
        //     })
        //     Object.keys(results).forEach((key) => {
        //         const result = results[key]
        //         const unit = action.quantumstate["turn:+1:start"].units.find((unit) => unit.key == key)
        //         if(unit != undefined) {
        //             unit.health += result.health
        //             unit.isDead = unit.health <= 0
        //         }
        //     })
        // })
        // action.quantumstate["turn:+1:start"] = {
        //     // "units": action.shadowunits.map((unit) => {
        //     //     return {
        //     //         "key": unit.key,
        //     //         "delta": {"health": 0},
        //     //         "alpha": clonedeep(unit),
        //     //         "omega": {/*to be computed*/}
        //     //     }
        //     // }),
        //     "tiles": clonedeep(action.shadowtiles),
        //     "units": clonedeep(action.shadowunits),
        // }
        mark4()

        ///////////////////
        // FLOW ACTIONS //
        /////////////////

        // This is where we flow to all the neighboring
        // tiles. These checks do not verify whether the
        // unit can move to this tile or act on this tile,
        // but it does propagate the actions to check.

        action.nextActions = []

        const mark7 = Speedtest.mark("Unit.flowActions", "flow: move")
        const omegaperformer = action.omegastage.units[action.performerKey]

        if(action.type == "move"
        || action.type == "wait"
        || action.type == "move through") {
            if(omegaperformer.isDead != true
            // && omegaperformer.state != "idle"
            // && omegaperformer.energy["move"] == true
            && action.distance < omegaperformer.moverange
            && Unit.isFlinching(omegaperformer) == false) {
                Geometry.getNeighborPoints(action.position).forEach((neighborposition) => {
                    if(action.positions.find((previousPosition) => Geometry.equals(previousPosition, neighborposition))) {
                        return
                    }
                    const nextTerrain = World.getTerrain(action.alphastage.world, neighborposition)
                    if(nextTerrain == undefined) return // TODO: SHOULD WE REALLY BE DOING THE WORLD COLLISION CHECK HERE?
                    let distance = MOVE_COST
                    if(nextTerrain.isPath) distance = MOVE_COST / 2
                    // if(nextTerrain.isTree) distance = MOVE_COST * 2
                    if(action.distance + distance > omegaperformer.moverange) return
                    action.nextActions.push({
                        "type": "move",
                        "performerKey": action.performerKey,
                        "position": neighborposition,
                        "distance": action.distance + distance,
                        "alphastage": action.alphastage,
                        "previousAction": action, // used for prior positions
                        "influenceMap": action.influenceMap,
                        "direction": Geometry.direction(neighborposition, action.position),
                    })
                })
            }
        }
        mark7()

        const mark8 = Speedtest.mark("Unit.flowActions", "flow: invoke skill")
        if(action.type == "move"
        || action.type == "wait"
        || action.type == "wait - invoke skill") {
            if(omegaperformer.isDead != true
            && omegaperformer.energy["invoke skill"] == true
            && omegaperformer.skillKeys != undefined) {
            // && Unit.isFlinching(omegaperformer) == false) {
                function calculateSkill(item, skillKey) {
                    skillKey = skillKey || item?.skillKey
                    // const skillKey = omegaperformer.skillKeys[skillSlot]
                    if(skillKey == undefined
                    || skills.get(skillKey) == undefined) {
                        return
                    }
                    const skill = skills.get(skillKey)
                    if(skill.type == "invoke") {
                        let positions = []
                        if(skill.range != undefined && skill.range.type == "findCollisionInDirection") {
                            Object.values(Geometry.orthodirections).forEach((direction) => {
                                positions = positions.concat(Stage.findCollisionInDirection({
                                    "stage": action.omegastage,
                                    "position": omegaperformer.position,
                                    "direction": direction,
                                    "maxdistance": (skill.range && skill.range.max) ?? item?.attackrange ?? omegaperformer.attackrange,
                                    "options": (skill.range && skill.range.options),
                                }).positions)
                            })
                        } else {
                            positions = Geometry.getNeighborPoints(action.position, skill.range ?? item?.attackrange ?? omegaperformer.attackrange)
                        }

                        positions.forEach((position) => {
                            action.nextActions.push({
                                "type": "invoke skill",
                                "item": item,
                                "skillKey": skillKey,
                                "performerKey": action.performerKey,
                                "position": position,
                                "alphastage": action.alphastage,
                                "previousAction": action, // used for steps and positions
                                "influenceMap": action.influenceMap,
                                "direction": Geometry.direction(position, action.position),
                            })
                        })
                    }
                }
                Object.values(omegaperformer.skillKeys).forEach((skillKey) => {
                    calculateSkill(undefined, skillKey)
                })
                Object.values(omegaperformer.items ?? [omegaperformer.primaryItem, omegaperformer.secondaryItem, omegaperformer.tertiaryItem]).sort((a, b) => {
                    if(a == omegaperformer.equippedItem) return -1
                    if(b == omegaperformer.equippedItem) return +1
                    return 0
                }).forEach((item) => {
                    if(item == undefined) return
                    (item.skillKeys || [item.skillKey]).forEach((skillKey) => {
                        calculateSkill(item, skillKey)
                    })
                })
            }
        }
        mark8()

        return action
    }
    static saveAction(actionmap, action) {
        const mark = Speedtest.mark("Unit.calculateAction", "save the action")

        // What makes each action different, even if they share a position and performer?
        // distance is NOT the same
        // skill + type is NOT the same
        // prev actions are NOT the same
        // (probably more, now. this list is very old)

        action.key = action.type + ":" + action.positions.map(Geometry.toString).reverse().join(">")

        const positionkey = action.position.x + "x" + action.position.y // + "x" + action.position.z // DEBUG DID A BAD THING HUH
        actionmap[positionkey] = actionmap[positionkey] || []
        actionmap[positionkey].push(action)

        mark()
        return actionmap
    }
    static calculateActionExperience(alphastage, omegastage, performerUnitKey, targetUnitKey, skillKey, {isCounterattack} = {}) {
        const steps = []

        if(targetUnitKey != undefined
        && performerUnitKey != undefined
        && omegastage.units[targetUnitKey] != undefined
        && omegastage.units[performerUnitKey] != undefined) {
            const performer = omegastage.units[performerUnitKey]
            const target = omegastage.units[targetUnitKey]

            if(performer.maxexperience != undefined) {
                performer.experience = performer.experience || 0
                let totalExperience = performer.experience
                let accruedExperience = 0

                if((performer.levelingCriteria == undefined
                || performer.levelingCriteria?.includes("attacking"))
                && alphastage.units[target.key].health > omegastage.units[target.key].health) {
                    let experience = 10
                    totalExperience += experience
                    accruedExperience += experience
                }

                if((performer.levelingCriteria == undefined
                || performer.levelingCriteria?.includes("killing"))
                && target.isDead == true) {
                    let experience = 5
                    totalExperience += experience
                    accruedExperience += experience
                }

                if(performer.levelingCriteria?.includes("healing")
                && skillKey == "restore-health"
                && omegastage.units[target.key].health > alphastage.units[target.key].health) {
                    let experience = 10
                    totalExperience += experience
                    accruedExperience += experience
                }

                if(accruedExperience > 0) {
                    steps.push(Step.instantiate({
                        "name": "print experience",
                        "type": "invoke skill",
                        "alphastage": omegastage,
                        "deltastages": PlotFlourishes.TextFloat({
                            "mark": 0,
                            "color": "#62C370",
                            "stack": "experience",
                            "unitKey": performer.key,
                            "position": performer.position,
                            "text": accruedExperience + "xp" + (accruedExperience > 10 ? "!" : ""),
                        })
                    }))

                    steps.push(Step.instantiate({
                        "name": "get experience",
                        "type": "invoke skill",
                        "alphastage": omegastage,
                        "deltastages": [
                            {
                                "mark": 0,
                                "unit": {"key": performer.key, "experience": performer.experience}
                            },
                            {
                                "mark": 10 * (totalExperience - (performer.experience || 0)),
                                "unit": {"key": performer.key, "experience": totalExperience}
                            }
                        ]
                    }))
                    omegastage = steps[steps.length - 1].omegastage
                }
            }

            if(target.maxexperience != undefined) {
                target.experience = target.experience || 0
                let totalExperience = target.experience

                if(target.levelingCriteria?.includes("tanking")
                && alphastage.units[target.key].health > omegastage.units[target.key].health) {
                    let experience = 10 // alphastage.units[target.key].health - omegastage.units[target.key].health
                    totalExperience += experience

                    steps.push(Step.instantiate({
                        "name": "print experience",
                        "type": "invoke skill",
                        "alphastage": omegastage,
                        "deltastages": PlotFlourishes.TextFloat({
                            "mark": 0,
                            "color": "#62C370",
                            "stack": "experience",
                            "unitKey": performer.key,
                            "position": performer.position,
                            "text": experience + "xp" + (experience > 10 ? "!" : ""),
                        })
                    }))
                    omegastage = steps[steps.length - 1].omegastage

                    steps.push(Step.instantiate({
                        "name": "get experience from tanking",
                        "type": "invoke skill",
                        "alphastage": omegastage,
                        "deltastages": [
                            {
                                "mark": 0,
                                "unit": {"key": target.key, "experience": target.experience}
                            },
                            {
                                "mark": 10 * (totalExperience - (performer.experience || 0)),
                                "unit": {"key": target.key, "experience": totalExperience}
                            }
                        ]
                    }))
                    omegastage = steps[steps.length - 1].omegastage
                }
            }
        }

        if(App?.game?.configuration?.immediateLevelups == true) {
            const units = Object.values(omegastage.units).filter((unit) => {
                return unit.isDead == false
                    && unit.affiliation == omegastage.player.affiliation
                    && unit.type != "spot" && unit.type != "zone"
            })

            units.forEach((unit) => {
                if(unit.experience >= unit.maxexperience
                && unit.experience < 99999 // TODO: use a tag here!!
                && unit?.levelups[unit.level + 1] != undefined) {
                    steps.push(Step.instantiate({
                        "duration": Infinity,
                        "isImportant": true,
                        "alphastage": omegastage,
                        "deltastages": [
                            {
                                "dialogue": {
                                    "type": "CharacterLevelUp",
                                    "data": {
                                        "unitKey": unit.key
                                    }
                                }
                            }
                        ]
                    }))
                    steps.push(Step.instantiate({
                        "duration": Infinity,
                        "isImportant": true,
                        "alphastage": omegastage,
                        "deltastages": [
                            {
                                "unit": {
                                    "key": unit.key,
                                    "experience": 99999, // TODO: use a tag here!!
                                    // "experience": unit.experience % unit.maxexperience, // only levels up once.
                                    "level": unit.level + 1,
                                }
                            },
                            ...omegastage.units[unit.key].levelups[unit.level + 1].map((levelupPerk) => {
                                if(levelupPerk.key == "maxhealth") {
                                    return {
                                        "unit": {
                                            "key": unit.key,
                                            "maxhealth": unit.maxhealth + levelupPerk.value
                                        }
                                    }
                                } else if(levelupPerk.key == "maxexperience") {
                                    // return {
                                    //     "unit": {
                                    //         "key": unit.key,
                                    //         "maxexperience": unit.maxexperience + levelupPerk.value
                                    //     }
                                    // }
                                } else if(levelupPerk.key == "power") {
                                    return {
                                        "unit": {
                                            "key": unit.key,
                                            "power": (unit.power || 0) + levelupPerk.value
                                        }
                                    }
                                }
                                // TODO: eventually add support to mid-level level-ups for jobs and skills.
                            })
                        ]
                    }))
                    omegastage = steps[0].omegastage
                }
            })
        }

        return steps
    }
    static pruneInternalActionMapData(actionmap) {
        Objdict.forEach(actionmap, (actionmaptile) => {
            actionmaptile.forEach((action) => {
                delete action.previousAction
                delete action.nextActions
                delete action.isStartingAction
                // distance
                // influenceMap
                // performerKey
                // skillKey
                // type
                // steps
                // omegastage
                // alphastage
                // positions
                // position
                // priority
            })
        })
        return actionmap
    }
    static protocopy(unit) {
        const shortUnit = {}
        if(unit == undefined) return undefined
        Object.keys(unit).forEach((key) => {
            if(key == "cachedProperties") return
            shortUnit[key] = unit[key]
        })
        return shortUnit
    }
    static clean(unit) {
        Object.keys(unit).forEach((key) => {
            if(unit[key] == undefined) delete unit[key]
            if(typeof unit[key] === "object"
            && Object.keys(unit[key]).length == 0) delete unit[key]
        })
        return unit
    }
    static copy(unit) {
        if(unit == undefined) return undefined
        let omegaunit = {
            ...unit,

            // The following properties are embedded objects
            // that are expected to be deep cloned. Any other
            // deep objects are NOT deep cloned.
            "position": unit.position && {
                ...unit.position
            },
            "energy": unit.energy && {
                ...unit.energy
            },
            "inventory": unit.inventory && {
                "items": {
                    ...unit.inventory.items
                }
            },
            "ai": unit.ai && {
                "state": unit.ai.state,
                "behaviors": unit.ai.behaviors
            },
        }
        delete omegaunit.actionmap
        return omegaunit
        // In the eventual schema,
        // be sure to mention that
        // position, energy and
        // inventory are deepcloned!!
        // Along with whatever properties
        // are listed in delta.
        // And how the property is defaulted
        // in Unit.initialize!!
        // Are we consistently calling unit.
        // unit.initiatlive when we spawn
        // units in scripts??

        // set during instantiation:
        // - equippedItem
        // - health, armor, experience
        // - skills from unlockedSkills
        // is there anything else SET Tto the model?
        // or is everything else just sanely assumed
        // to have values when null?

        // ai is fully set, is not cloned, do not edit, only full replace
        // STATE IS AUTOMAGICALLY SET

        const EXAMPLE_UNIT = {
            // {String} unit.key
            // The unique identifier for the unit. All units keyed under this
            // value, so there can truly only be one. For player characters, we
            // try to make these easy-to-remember human-readable values, like
            // "viking" or "cowboy," since we use these keys in scripting.
            "key": "swashbuckler",

            // {Object} unit.position
            // {Number} unit.position.x
            // {Number} unit.position.y
            // {Number} unit.position.z
            // The point in space that this unit occupies. X and Y are the
            // horizontal coordinates, and for our two dimensional gameplay,
            // all we really need. But you can optionally add a Z for vertical
            // coordinates, which is useful for pushing characters off ledges.
            "position": {"x": 4, "y": 6, "z": 1},

            // {Object} unit.direction
            // {Number} unit.direction.x (meant to be either -1 / 0 / +1)
            // {Number} unit.direction.y (meant to be either -1 / 0 / +1)
            // The direction the unit is facing, usually the direction of their
            // last action, be it moving in this direction or attacking in this
            // direction. Historically, we've had some games that would render
            // different sprites depending on which direction our unit was
            // facing. But we haven't done that in a long while.
            "direction": {"x": 0, "y": -1},

            // {String} unit.jobKey
            // The unit's job, which you can consider like their rpg class or
            // a generic prefab template. During initialization, we copy all
            // the properties of that job into this unit, such as job-related
            // stats. But if, in addition to a job, this unit also defines their
            // own stats, those values will override the values from the job.
            "jobKey": "pirates/swordsman",

            // {String} unit.randomJobKey (comma-delimited list of job keys)
            // If, during initialization, the unit has no jobKey but has a
            // randomJobKey, it will use
            "randomJobKey": "pirates/swordsman,pirates/spearman,pirates/axeman",

            // {Number} unit.health
            // {Number} unit.maxhealth
            // The life of the unit!! If their health hits zero, the unit dies.
            // Their maxhealth is their total starting health - if a unit has
            // no health during initialization, it is set to their maxhealth.
            // Try to keep the maxhealth to something divisible by 10, since
            // each segment of the healthbar is relative to 10 health points.
            // Most units start with around 30 health points.
            "health": 10,
            "maxhealth": 50,

            // {Number} unit.armor
            // {Number} unit.maxarmor
            // Armor is an optional design feature. At the moment, we don't have
            // any games that use armor, but we support it for design posterity.
            // If a unit has armor, they have a secondary health bar. All attacks
            // must first deplete the armor bar before you can deplete the health
            // bar. Think of it like temporary hp from D&D 5e.
            "armor": 30,
            "maxarmor": 30,

            // {String} unit.armortype (either "magic" or "steel")
            // If a unit has an armortype, then their health bar only eats
            // damage of that type. If a unit has magical armor, all magical
            // attacks must eat through the armor bar before hitting the health
            // bar. But all physical weapon attacks will skip to the health bar.
            // Consult attacktype to see if an attack is magical or physical.
            "armortype": "steel",

            // {Number} unit.defense
            // {Number} unit.resistance
            // If a unit has defense or resistance, they can reduce the damage
            // of all incoming attacks. Their defense will reduce all physical
            // attacks, and their resistance will reduce all magical attacks.
            // Consult attacktype to see if an attack is magical or physical.
            // Be careful with these stats!! They're very powerful.
            "defense": 3,
            "resistance": 0,

            // {Number} unit.luck
            // We, uh, don't actually use this property for anything yet. But
            // maybe someday? Until then, it is just a funny number.
            "luck": 69,

            // {Number} unit.moverange
            // The number of tiles a unit can reach with their movement. If they
            // have a moverange of 1, they can only move to adjacent tiles.
            // If they have a moverange of 0, they can't move at all. Most
            // units will only ever have a moverange of 2.
            "moverange": 2,

            // {String} unit.movetype (such as "flying" or "walking")
            // If a unit has a movetype of "flying", they can fly over most
            // obstructions!! We might eventually add other movetypes, but for
            // now, we only support "flying."
            "movetype": "walking",

            // {Array of Strings} unit.properties
            // A list of unit properties, such as "captain of the ship" or
            // "never gives up" - think of these like aspects in Fate 3e. We
            // mostly use these in skills or scripts to apply special behavior
            // to certain units. As seen below, this unit has the backstabbing
            // property, which allows them to attack their allies.
            "properties": ["backstabbing"],

            // {Number} unit.power
            // The attack strength of a unit!! This is how much damage they can
            // deal each turn. Most units start with around 20 power.
            "power": 20,

            // {String} unit.attacktype {either "magic" or "steel"}
            // Whether their weapon is magical or physical. When attacking an
            // enemy with magic armor, the armor will eat all magical damage.
            "attacktype": "steel",

            // {Number} unit.attackrange
            // {Range Object} unit.attackrange
            // The number of tiles a unit can reach with their attacks. If they
            // have an attackrange of 1, they can only attack adjacent units. If
            // a unit has an attackrange of 2, they can ONLY attack units that
            // are exactly 2 tiles away.
            // For more complex ranges, you can instead give a range object.
            // https://github.com/ehgoodenough/frog-tactics/wiki/Data:Range
            "attackrange": 1,

            // {String} unit.element (keys into data/elements.js)
            // The elemental "resonance" of a unit. If a unit has an elemental
            // advantage against another unit (such as water vs fire), then the
            // unit attacks them twice!!
            // As a rule of thumb, most swords and daggers are fire, most spears
            // and bows are water, and most axes and guns are earth. They're not
            // literally doing elemental damage, but they "resonante" with that
            // primordial elemental.
            "element": "fire",

            // {Array of Strings} unit.skillKeys
            // A list of all the skills the unit can perform as their action.
            // The skills are listed by key, which indexes into data/skills.js.
            // https://github.com/ehgoodenough/frog-tactics/wiki/Data:Skill
            "skillKeys": ["attack", "interact", "push"],

            // {Dictionary of Item Objects} unit.items
            // https://github.com/ehgoodenough/frog-tactics/wiki/Data:Item
            // A list of all the items the unit is carrying, key'd by their key.
            "items": {
                "123": {
                    "key": "123",

                    "name": "Sword",
                    "weaponAudiokey": "slash",
                    "weaponImageKey": "sword",
                    "inventoryImageKey": "Attack:Slash",

                    "skillKeys": ["attack"],
                    "attacktype": "steel",
                    "attackrange": 1,
                    "element": "fire",
                },
            },

            // {Item Object} unit.equippedItem
            // {String} unit.equippedItemKey (keys into unit.items)
            // The item currently equipped by the unit. While weilding an item,
            // the item's skills are available to the unit. While weidling an
            // item, the item's stats will temporarily mask the unit's stats. So
            // while weilding fire, the unit is weak to water. And while weilding
            // water, the unit is weak to earth.
            "equippedItemKey": "123",

            // {Boolean} unit.isDead
            // When a unit has no more hit points, they are dead. A dead unit
            // is no longer renderable and no longer collidable. It is often
            // used for winning or losing an encounter.
            "isDead": false,

            // {Boolean} unit.isRemoved
            // When a unit has left the encounter, it is marked as "removed."
            // Similar to a dead unit, it is no longer renderable or collidable.
            // But it isn't dead, just gone.
            "isRemoved": false,

            // {Boolean} unit.energy.act
            // {Boolean} unit.energy.move
            // Each turn, a unit can take a move (equal to unit.moverange) and
            // an act (a use of a unit.items or a unit.skillKeys). At the start
            // of their turn, their unit.energy.move and unit.energy.act is set
            // to true. But after they have taken their movement and action,
            // their unit.energy.move and unit.energy.act is set to false.
            "energy": {
                "act": true,
                "move": true,
            },

            // {String} unit.affiliation (usually "good" or "bad")
            // Each turn, all units take their actions. If units share an
            // affiliation, they take their actions together. The player has
            // an affiliation, as defined in stage.player.affiliation, and can
            // command all units of their affiliation.
            // You can set the affiliation to whatever you want. For some games,
            // it might be enough to just have "good" and "bad," but you could
            // always add "ugly."
            "affiliation": "good",

            // {Object} unit.ai
            // A set of properties used by the ai to determine what actions this
            // unit might take. If a unit is commanded by the player, these
            // properties doesn't affect their actions whatsoever.
            "ai": {
                // {String} unit.ai.state ("waiting", "aggroed" or "pacified")
                // All units usually start aggroed and if they aren't aggroed,
                // are aggroed after being attacked. An aggroed unit will move
                // towards an enemy, even if their attacks can't reach them yet.
                // Some units might be set to waiting, usually as part of the
                // level design. A waiting unit will not make any moves towards
                // an enemy unless the enemy is in range for an attack.
                // And lastly, a unit might be set to pacified, usually by some
                // action by the player. A pacified unit doesn't take any
                // movement or action against anyone. (Unless they are
                // attacked, which will set them to aggroed)
                "state": "aggroed",

                // {Array of Strings} unit.ai.behaviors
                // A list of special behaviors that encourages a unit to
                // prioritize certain actions over others (like "healing first",
                // which prioritizes healing an ally over hurting an enemy), or
                // forbids a unit from taking certain actions (like "never
                // attacks players", which forbids a unit from attacking any
                // unit affiliated with the player)
                "behaviors": [
                    "healing first"
                ]
                // TODO: Properly document all the possible behaviors!! At the
                // moment, we don't support that many pbehaviors, since we're
                // still feeling out what ai behaviors we actually need.
            },

            // {Map of Arrays of Action Objects} unit.actions
            // https://github.com/ehgoodenough/frog-tactics/wiki/Data:Action
            // A map of different actions the unit can take, key'd by the
            // position of that action. They could go north and attack, or go
            // south and heal! Each possible position can have many possible
            // actions they could take, which is why each position has an array
            // of different actions.
            // The unit.actions is never authored, but computed at the start of
            // each turn by Stage.calculateActions and Unit.calculateActions.
            "actions": {
                "5x6": [Action, Action, Action],
                "3x6": [Action],
                "4x5": [Action, Action],
                "4x7": [Action, Action, Action, Action],
            },

            // {String} unit.name
            // {String} unit.title
            // The displayed name of the unit, printed in the HUD.
            "name": unit.name,
            "title": unit.title,

            // {String} unit.jobName
            // {String} unit.subtitle
            // The displayed class of the unit, printed in the HUD.
            // Usually in smaller text beneath the unit's name or title.
            "jobName": unit.jobName,
            "subtitle": unit.subtitle,

            // {Dictionary of Strings} unit.sprites
            // A collection of image urls to render at the unit's position on
            // the map. Each image is key'd by a spriteKey, such as "neutral"
            // or "attacking" or "attacked."
            "sprites": {
                "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/eleanora.png")
                // TODO: Document the extensive animation options for unit sprites, as seen in ember.
            },

            // {String} unit.spriteKey (keys into unit.sprites)
            // The current sprite to render, as defined in unit.sprites. If no
            // spriteKey is defined, it is assumed to be "neutral".
            "spriteKey": "neutral",

            // {String} unit.spriteSize
            // The size that the unit.image should be rendered. We support
            // 1x1 and 2x3 and 4x3. If undefined, it is assumed they are 1x1.
            "spriteSize": "4x3",

            // {String} unit.spriteHead
            // {String} unit.spriteHeadKey
            // A sprite to render on top of the unit, maybe as a jaunty hat, or
            // maybe as an angry expression. Some units can also be composed
            // piece-by-piece, using both unit.spriteHead and unit.spriteBody.
            "spriteHeadKey": "angry",

            // {String} unit.spriteBody
            // {String} unit.spriteBodyKey
            // A sprite to render on bottom of the unit, maybe as a cool shield,
            // or maybe an alternate outift. Some units can also be composed
            // piece-by-piece, using both unit.spriteHead and unit.spriteBody.
            "spriteBodyKey": "shield",

            // {String} unit.animationKey (something like "shanty" or "bob")
            // The name of a css keyframe animation to loop on the unit sprite.
            // This should not be confused with frame-by-frame sprite animations
            // that can be coded into unit.sprites. These css animations are
            // mostly for rotating or translating the unit sprites.
            // For a full list of support animations, see views/UnitSprite.less
            // https://github.com/ehgoodenough/frog-tactics/blob/main/source/views/components/UnitSprite.less
            "spriteAnimationKey": "shanty",

            // {Dictionary of Strings} unit.portraits
            // A collection of image urls to render the unit during dialogue.
            // Each image is key'd by a portraitKey, such as "happy" or "angry."
            // These keys are referenced during dialogue as their "expressions."
            // The portrait is also used in the HUD when hovering over a unit.
            // If the unit has a portrait for attacking or attacked, that image
            // will be used in the HUD during combat.
            "portraits": {
                "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-neutral.png"),
                "happy": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-happy.png"),
                "angry": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                "attacking": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                "attacked": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
            },

            // {Number} unit.stack
            // For two units in the same or adjacent positions, you can set this
            // value to have them rendered above the other unit. The higher the
            // value, the higher they are on the stack.
            "stack": 1,

            // {Dictionary of Arrays of Steps} unit.scripts
            // https://github.com/ehgoodenough/frog-tactics/wiki/Data:Step
            // A collection of events to trigger at dramatic moments, like when
            // the unit is killed or betrayed.
            "scripts": {
                "death": [
                    "SWASHBUCKLER: Fuck, that's it for me.",
                ]
            },

            // {Number} unit.level
            // {Number} unit.maxlevel
            // {Number} unit.experience
            // {Number} unit.maxexperience
            // {Array of Strings} unit.levelingCriteria
            // {Dictionary of ???} unit.levelups
            "level": 1,
            "experience": 10,
            "maxexperience": 50,
            "levelingCriteria": ["attacking", "killing", "healing"],
            "levelups": {
                "2": [
                    {"key": "maxhealth", "value": 10},
                    {"key": "maxexperience", "value": 50},
                    {"key": "skill", "value": "push"},
                ],
                "3": [
                    {"key": "maxhealth", "value": 10},
                    {"key": "maxexperience", "value": 50},
                    {
                        "key": "jobKeys",
                        "values": [
                            "hero/bladesinger",
                            "hero/firefist"
                        ]
                    },
                ],
                "4": [
                    {"key": "maxhealth", "value": 10},
                    {"key": "maxexperience", "value": 50},
                ],
            },
            // TODO: Document the levelup properties!!

            // // LEGACY //
            // "facts": unit.facts,
            // "introduction": unit.introduction,
            // // "subclasses": unit.subclasses,
            // "data": unit.data,
            // "disableHealth": unit.disableHealth, // YIKES I WISH WE JUST DIDN'T ADD HEALTH TO BEGIN WITH (WITHOUT DEATH KICKING IN FOR THE HEALTHLESS ENTITY)
            // "isHidingHealthbar": unit.isHidingHealthbar,
            // "isNotRendered": unit.isNotRendered, // bruh
            // "isVisible": unit.isVisible,
            // "canWalkOntoTheZone": unit.canWalkOntoTheZone, // i mean like ok this too...??
            // "spawnspot": unit.spawnspot,
            // "canBetray": unit.canBetray,
            // "isRecruited": unit.isRecruited,
            // "isRecruitable": unit.isRecruitable,
            // "deathTimer": unit.deathTimer,
            // "hasSlowDeath": unit.hasSlowDeath,
            // "type": unit.type,
            // "role": unit.role,
            // "intent": unit.intent, // JUST FOR KILLZONES...?
            // "spotTag": unit.spotTag,
            // "tag": unit.tag, // using this for spawn point groups. spawn left or right, for example.
            // "protounit": unit.protounit, // used in ember for storing something to spawn
            // "protoMonsterKey": unit.protoMonsterKey, // used in ember for storing something to spawn
            // "item": unit.item, // just using this for animating an item above a character's head.
            // // primaryitems should have properites too
            // "secondaryItem": unit.secondaryItem, // to be replaced by inventory!!
            // "primaryItem": unit.primaryItem, // to be replaced by inventory!! - with one item being marked as the "default" or "preferred"
            // // "decalImageKey" -> should be offhand image key!! could be a separate item definition...?
            // // "score": unit.score, // deprecated, but used to be used for tracking points per kill!!
            // // // Deprecated for now, but we should bring this back eventually.
            // // // deep cloned
            // // "effects": Objdict.map(unit.effects, (effect) => {
            // //     const reeffect = {
            // //         "type": effect.type,
            // //         "timer": effect.timer,
            // //     }
            // //     for(let key in effect) {
            // //         if(effect[key] != undefined) {
            // //             reeffect[key] = effect[key]
            // //         }
            // //     }
            // //     return reeffect
            // // }),
            // "nextAffiliation": unit.nextAffiliation,
            // "preferredAffiliation": unit.preferredAffiliation, // pirates
            // "betrayedAffiliation": unit.betrayedAffiliation, // pirates
            // "color": unit.color, // healthbar color?
            // // top-level power and element and attackrange and attacktype?? Should I make a "unhanded" item, so it isn't toplevel?
            // "weaponImageKey": unit.weaponImageKey,
            // "weaponAudioKey": unit.weaponAudioKey,
            // // {String} unit.image (url)
            // // {String} unit.imageKey (keys into data/unitSprites.js)
            // // If a unit has no sprites, it can also just set a single image
            // // using unit.image or unit.imageKey.
            // "imageKey": "swashbuckler",
            // // {String} unit.portrait (url)
            // // {String} unit.portraitKey (keys into unit.portraits)
            // "portrait": unit.portrait, // this is a url string
            // "portraitKey": unit.portraitKey, // this keys into unit.portraits
        }
    }

    //////////////
    // Getters //
    ////////////
    static isFlinching(unit) {
        if(unit.effects != undefined) {
            return !!Objdict.find(unit.effects, (effect) => {
                return effect.type == "flinch"
            })
        }
    }
}
// // THIS IS PRETTY OUT OF DATE
// const exampleAction = {
//     "type": String, // "move"|"invoke"|"assist"|"move through"|"invoke skill"
//     "stage": Stage,
//     "performer": Unit,
//     "target": Unit,
//     "position": Point, // position of this action
//     "distance": Number, // shortest orthogonal distance from the starting action.
//     "isStartingAction": Boolean,
//     // THE STATE **BEFORE** THE ACTION IS PERFORMED
//     "alphastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     // THE STATE **AFTER** THE ACTION IS PERFORMED
//     "omegastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     "results": {
//         "target": {
//             "health": -1, // remove one health
//             "position": {"x": -1, "y": 0}, // move left one tile
//         },
//         "peformer": {
//             "health": +1
//         },
//     },
//     "counterAction": Action,
// }

// TODO: hey is it documented anywhere that action.positions are in reverse order, so action.positions[0] is the current position, and action.positions[1] is the last position?

// ACTIONS are a single discrete input that the player/ai has
// chosen. They are legal actions to perform from the current
// state: within range, respecting targets, etc. They include
// a list of steps/beats.

// STEPS/BEATS are the execution of an action, or a script.
// They include there own discrete edit onto the world, with
// all the details necessary to perform it. It includes both
// the state BEFORE and AFTER the step is performed. They can
// be overlapped or combined by the director.
